// MENGENRECHNER fuer hamburgerlackprofi (24.09.2026, Finn: „genauso wie bei Farbenlöwe“).
// Gegenstueck zu snippets/fl-mengenrechner.liquid: Das Snippet traegt Ergiebigkeit und Texte der
// Sprache am Popup (data-*), hier stehen keine Woerter und keine Zahlen fest. Farbenloewe nutzt
// assets/quantity_calculator.js mit denselben CSS-Klassen (tiktok-block.css).
//
// Jeder Rechner gehoert zu SEINEM Varianten-Waehler (Kaufleiste, Schnellkauf).
// Gerechnet wird wie bei farbenloewe: Liter = Flaeche / 10, auf halbe Liter aufgerundet, mindestens 1 (11 m² -> 1,5 Liter).
// Finn 24.09.2026: „die von Farbenlöwe sind richtig … Verbrauch von 10 bis 12 m² pro Liter“.
(function () {
  if (window.flMengenrechner) return
  window.flMengenrechner = true

  function popupZu (el) {
    var vp = el && el.closest ? el.closest('variant-picker') : null
    return vp ? vp.querySelector('[data-fl-mr]') : null
  }

  function konfig (p) {
    return {
      min: parseFloat(p.getAttribute('data-min')) || 0,
      max: parseFloat(p.getAttribute('data-max')) || 0,
      deck: p.getAttribute('data-t-deck') || '',
      ca: p.getAttribute('data-t-ca') || '',
      l1: p.getAttribute('data-t-l1') || 'L',
      ln: p.getAttribute('data-t-ln') || 'L',
      l1bis: parseFloat(p.getAttribute('data-t-l1-bis')) || 1
    }
  }

  // "2,5 L" -> 2.5; "30 kg" zaehlt wie bei farbenloewe als 20 L; anderes -> null
  function liter (text) {
    var t = String(text || '').replace(/\s+/g, '').toLowerCase()
    if (t === '30kg') return 20
    var m = t.match(/^(\d+(?:[.,]\d+)?)l$/)
    return m ? parseFloat(m[1].replace(',', '.')) : null
  }

  function deckungText (k, wert) {
    var n = liter(wert)
    if (n === null || !k.min) return ''
    var a = Math.round(n * k.min), b = Math.round(n * k.max)
    var flaeche = a === b ? (k.ca + ' ' + a) : (a + '–' + b)
    return ' (' + k.deck.replace('{a}', flaeche) + ')'
  }

  function deckungAktualisieren () {
    var spans = document.querySelectorAll('[data-fl-mr-deckung]')
    for (var i = 0; i < spans.length; i++) {
      var p = popupZu(spans[i])
      var fs = spans[i].closest('fieldset')
      var wert = fs && fs.querySelector('variant-option-value')
      if (p && wert) spans[i].textContent = deckungText(konfig(p), wert.textContent)
    }
  }

  function rechnen (p) {
    var k = konfig(p)
    if (!k.min) return
    var input = p.querySelector('.mengenrechner-input')
    var ziel = p.querySelector('.mengenrechner-result')
    if (!input || !ziel) return
    var flaeche = Math.max(1, parseInt(input.value, 10) || 1)
    // Halbe Liter (Finn 24.09.2026): 25 m² -> 2,5 L, passend zu "2,5 L reicht fuer 25–30 m²"; mindestens 1 L.
    var l = Math.max(1, Math.ceil(flaeche * 2 / k.min) / 2)
    ziel.textContent = String(l).replace('.', ',') + ' ' + (l <= k.l1bis ? k.l1 : k.ln)
  }

  function sauber (v) { return String(v || '').replace(/\D/g, '').slice(0, 7) }

  function oeffnen (p) {
    p.classList.add('active')
    p.setAttribute('aria-hidden', 'false')
    var input = p.querySelector('.mengenrechner-input')
    setTimeout(function () { input.focus(); input.select() }, 100)
  }

  function schliessen (p) {
    p.classList.remove('active')
    p.setAttribute('aria-hidden', 'true')
    p.querySelector('.mengenrechner-input').value = '1'
    rechnen(p)
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mengenrechner-link')
    if (link) { var z = popupZu(link); if (z) { e.preventDefault(); oeffnen(z) } return }
    var p = e.target.closest('[data-fl-mr]')
    if (!p) return
    if (e.target.closest('.mengenrechner-popup-close') || e.target === p) { schliessen(p); return }   // auch Klick neben den Dialog
    var btn = e.target.closest('.mengenrechner-qty-btn')
    if (btn) {
      var input = p.querySelector('.mengenrechner-input')
      var v = parseInt(input.value, 10) || 1
      v += btn.getAttribute('data-action') === 'increase' ? 1 : -1
      input.value = String(Math.max(1, Math.min(9999999, v)))
      rechnen(p)
    }
  })

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-fl-mr] .mengenrechner-input')) return
    e.target.value = sauber(e.target.value)
    rechnen(e.target.closest('[data-fl-mr]'))
  })

  document.addEventListener('focusout', function (e) {
    if (!e.target.matches || !e.target.matches('[data-fl-mr] .mengenrechner-input')) return
    // Das Feld zeigt danach die Zahl, mit der gerechnet wird (rechnen() nimmt mindestens 1): "0" und "007" blieben sonst
    // stehen, waehrend das Ergebnis fuer 1 bzw. 7 m² galt (Codekarte 27.10.2026).
    e.target.value = String(Math.max(1, parseInt(sauber(e.target.value), 10) || 1))
    rechnen(e.target.closest('[data-fl-mr]'))
  })

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return
    var offen = document.querySelectorAll('[data-fl-mr].active')
    for (var i = 0; i < offen.length; i++) schliessen(offen[i])
  })

  // Groesse gewechselt: Beobachtet wird der ANGEZEIGTE Wert (variant-option-value), nicht die Art der
  // Auswahl. So stimmt die Flaeche nach Knopf, Dropdown oder Sprung ueber die Adresse gleichermassen
  // (Blindpruefer 24.09.: ein reiner change-Horcher auf Radios haette das Dropdown verpasst).
  var beobachtet = typeof WeakSet === 'function' ? new WeakSet() : null
  function beobachten () {
    if (!beobachtet || typeof MutationObserver !== 'function') return
    var spans = document.querySelectorAll('[data-fl-mr-deckung]')
    for (var i = 0; i < spans.length; i++) {
      var fs = spans[i].closest('fieldset')
      var wert = fs && fs.querySelector('variant-option-value')
      if (!wert || beobachtet.has(wert)) continue
      beobachtet.add(wert)
      new MutationObserver(deckungAktualisieren).observe(wert, { childList: true, characterData: true, subtree: true })
    }
  }
  document.addEventListener('change', function () { setTimeout(deckungAktualisieren, 0) })

  function start () {
    beobachten()
    deckungAktualisieren()
    var alle = document.querySelectorAll('[data-fl-mr]')
    for (var i = 0; i < alle.length; i++) rechnen(alle[i])
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()
